<template>
  <div class="contact-btns">
    <ul v-if="!$global.isMobile">
      <li :class="{ 'contact-detail-show': contactDetailShow }">
        <a class="contact-btn btn-free-trial"></a>
        <transition name="contact-show">
          <div class="contact-detail-panel">
            <div class="free-trial-wrap">
              <div class="close" @click="clickCloseFreeTrial">
                <img src="/static/images/close.png" alt="" />
              </div>
              <p class="title">欢迎使用{{ $global.siteName }}</p>
              <p>请点击下方按钮申请试用{{ $global.siteName }}</p>
              <!-- <p>客服热线：400-888-9725</p> -->
              <Button class="trial-btn" @click="showFreeTrialModal"
                >申请试用</Button
              >
            </div>
          </div>
        </transition>
      </li>
      <li @mouseenter="closeFreeTrial">
        <a class="contact-btn btn-phone"></a>
        <transition name="contact-show">
          <div class="contact-detail-panel">
            <div class="qr-code-wrap">
              <!-- <img src="/images_index/qrcode.png" class="qr-code" />
              <p class="title">请扫码加入QQ客服群</p> -->
              <p>客服热线</p>
              <p>400-888-9725</p>
            </div>
          </div>
        </transition>
      </li>
      <li v-if="false">
        <a class="contact-btn btn-qq"></a>
      </li>
    </ul>
    <ul v-else>
      <li>
        <a href="tel:400-888-9725" class="contact-btn btn-phone"></a>
      </li>
    </ul>
    <div class="contact-btns-bg" v-if="contackDetailCloseBtnShade"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactDetailShow: false,
      contackDetailCloseBtnShade: false,
      freeTrialShowTimeout: null
      // clienWidth: 0
    };
  },
  methods: {
    contactHover() {
      this.closeFreeTrial();
      this.freeTrialAutoShow();
    },
    clickCloseFreeTrial() {
      this.contactDetailShow = false;
      this.contackDetailCloseBtnShade = true;
      setTimeout(() => {
        this.contackDetailCloseBtnShade = false;
      }, 1000);
    },
    closeFreeTrial() {
      this.contactDetailShow = false;
      if (this.freeTrialShowTimeout) {
        clearTimeout(this.freeTrialShowTimeout);
      }
    },
    freeTrialAutoShow() {
      if (this.freeTrialShowTimeout) {
        clearTimeout(this.freeTrialShowTimeout);
      }
      this.freeTrialShowTimeout = setTimeout(() => {
        this.contactDetailShow = true;
      }, 5000);
    },
    showFreeTrialModal() {
      this.$emit("showFreeTrialModal");
    }
    // resize() {
    //   this.clienWidth = window.document.documentElement.clientWidth;
    // }
  },
  mounted() {
    if (window.sessionStorage.getItem("applyTrial") !== "1") {
      this.freeTrialAutoShow();
    }
  }
};
</script>

<style lang="scss">
@keyframes contact-out {
  0% {
    opacity: 1;
    transform: scale(1, 1);
    transform-origin: bottom right;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 0;
    transform: scale(0, 0);
    transform-origin: bottom right;
  }
}

@keyframes contact-in {
  0% {
    opacity: 0;
    transform: scale(0, 0);
    transform-origin: bottom right;
  }
  50% {
    opacity: 0.2;
    transform: scale(1.03, 1.03);
    transform-origin: bottom right;
  }
  100% {
    opacity: 1;
    transform: scale(1, 1);
    transform-origin: bottom right;
  }
}
// 联系我们
.contact-btns {
  position: fixed;
  right: 20px;
  bottom: 52px;
  z-index: 10;
  li {
    position: relative;
    .contact-btn {
      display: block;
      width: 44px;
      height: 44px;
      margin: 2px;
      padding: 4px;
      background-size: 100% 100%;
    }
    .btn-free-trial {
      background-image: url("/static/images/free-trial.png");
    }
    .btn-phone {
      background-image: url("/static/images/tel.png");
    }
    .btn-qq {
      background-image: url("/static/images/qq.png");
    }
    .contact-detail-panel {
      position: absolute;
      bottom: 10px;
      right: 50px;
      width: 314px;
      text-align: left;
      color: #333;
      border-radius: 10px;
      // background: #F9F9F9;
      background-color: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.13);
      transition: all 0.3s ease-in-out;
      // animation-duration: 300ms;
      // animation-name: contact2;
      // transition-timing-function: ease-in;
      overflow: hidden;
      visibility: visible;
      opacity: 0;
      transform: scale(0, 0);
      transform-origin: bottom right;
      padding: 20px 24px;
      max-width: 0;
      max-height: 0;
      .contact-tel,
      .contact-qrcode {
        padding: 14px;
      }
      .contact-tel {
        padding-bottom: 12px;
        background: #f9f9f9;
        .tel {
          font-size: 14px;
          font-weight: bold;
        }
      }
      .contact-qrcode {
        background: #fff;
        padding-top: 8px;
        border-radius: 0 0 10px 10px;
      }
      p {
        font-size: 12px;
        line-height: 20px;
      }
      .free-trial-wrap {
        .close {
          width: 12px;
          height: 12px;
          position: absolute;
          right: 10px;
          top: 10px;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          font-size: 16px;
          font-weight: 800;
          color: #333333;
          line-height: 22px;
          &.title {
            font-size: 20px;
            line-height: 32px;
          }
        }
        .trial-btn {
          width: 90px;
          height: 26px;
          line-height: 1;
          background: #0057ff;
          border-radius: 13px;
          color: #fff;
          margin-top: 10px;
        }
      }
      .qr-code-wrap {
        .qr-code {
          width: 88px;
          height: 88px;
          float: left;
          margin-right: 20px;
        }
        p {
          font-size: 14px;
          font-weight: 800;
          color: #333333;
          line-height: 20px;
          &.title {
            margin-bottom: 26px;
          }
        }
      }
    }
    &.contact-detail-show,
    &:hover {
      .contact-detail-panel {
        opacity: 1;
        transform: scale(1, 1);
        transform-origin: bottom right;
        max-width: 314px;
        max-height: 128px;
        // animation-duration: 300ms;
        // animation-name: contact2;
        // transition-timing-function: ease-in;
      }
    }
    &:nth-of-type(2) {
      .contact-detail-panel {
        width: 180px;
      }
    }
  }
}

.contact-btns-bg {
  width: 20px;
  height: 20px;
  background: transparent;
  position: absolute;
  right: 56px;
  bottom: 112px;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexContact.vue